import { useTranslation } from "../../../hooks/useTranslation";
import Button from "../../UI/Button";
import LoadingSkeleton from "../../UI/LoadingSkeleton";
import style from "./index.module.css";
import { onClickCallHandler } from "./utils";

const ShowroomHero = ({ name, logo, cover, note, phone, isServiceCenter = false, isLoading }: ComponentPropsType) => {
  const { locale } = useTranslation();

  return (
    <div className={style.hero}>
      {!isLoading && cover && (
        <div className={style.hero_cover}>
          {" "}
          <img src={cover} alt="" />
        </div>
      )}
      <div className={style.hero_header}>
        <div className={style.hero_header__title}>
          <div className={style.hero_header__image}>{!isLoading && logo && <img src={logo} alt="" />}</div>
          <div>
            {isLoading ? <LoadingSkeleton height="18px" width="160px" count={1} margin="0 0 5px" /> : <h3>{name}</h3>}
            {isLoading ? <LoadingSkeleton height="18px" width="160px" count={1} /> : <p>{note}</p>}
          </div>
        </div>
        <div className={style.hero_header__cta}>
          {isLoading ? (
            <LoadingSkeleton height="42px" width="200px" count={1} />
          ) : (
            <Button
              styleType="primary_black"
              onClick={(e: any) => onClickCallHandler(e, phone)}
              extraProps={{
                "data-clicked": "false",
              }}
            >
              {locale(`call_${isServiceCenter ? "center" : "showroom"}`)}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShowroomHero;

type ComponentPropsType = {
  logo: string;
  cover: string;
  name: string;
  note: string;
  phone: string;
  isLoading?: boolean;
  isServiceCenter?: boolean;
};
